export function getImgSize(
  isFilled: boolean | undefined,
  isCatalogueIcon: boolean,
  isStoresIcon?: boolean,
  isDesktop?: boolean
): string {
  if (isFilled) return '100%';

  if (isCatalogueIcon) return '26px';

  if (isStoresIcon) return isDesktop ? '95px' : '60px';

  return isDesktop ? '70px' : '50px';
}
